import Image from '@atoms/Image';
import ContactHeading from '@components/ContactUs/ContactHeading';
import ContactCard from '@components/ContactUs/ContactCard';
import ContactDetails from '@components/ContactUs/ContactDetails';
import {
    addressDetails,
    contactDetails,
    socialMediaIcons,
} from '@components/ContactUs/helper';
import { sendMessage } from '@services/message.service';
import { Fragment, useState, useEffect } from 'react';
import MessageToaster from '@atoms/MessageToaster';
import texts from '@components/ContactUs/en.json';
import SocialMediaIcons from '@components/ContactUs/SocialMediaIcons';
import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupValidator } from '@lib/yup-validator';
import isValidEmail from '@helpers/isValidEmail';

const ContactUS = () => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const contactForm = useForm({
        resolver: yupValidator(
            yup.object().shape({
                mobile: yup
                    .string()
                    .matches(/^[1-9]\d{9}$/, texts?.MobileNumberShouldBeValid)
                    .required(texts?.PhoneNumberIsRequired),
                email: yup.string().test('email-valid', texts?.EmailShouldBeValid, (v) => !v || isValidEmail(v)),
            })
        ),
    });
    const onSubmit = async (data) => {
        setLoading(true);
        const response = await sendMessage(data);

        if (response.status) {
            setMessage(texts?.SuccessfullySentTheMessage);
            contactForm.reset();
            clearMessage();
        } else {
            setError(true);
            setMessage(response.message);
            clearMessage();
        }
        setLoading(false);
    };
    const clearMessage = () => {
        setTimeout(() => {
            setMessage('');
        }, 3000);
    }
    return (
        <>
            <div className="w-full pt-12 md:pt-16">
                <div className="bg-white relative h-[356px] md:h-[216px]">
                    <div className="hidden md:block">
                        <Image
                            className="absolute right-0 top-0 bg-transparent"
                            src={`/images/contact-us/gradient-green.svg`}
                        />
                        <Image
                            className="absolute left-0 bottom-0 bg-transparent"
                            src={`/images/contact-us/gradient-violet.svg`}
                        />
                    </div>
                    <div className="md:hidden -z-100">
                        <Image
                            className="absolute right-0 bottom-0 bg-transparent"
                            src={`/images/contact-us/gradient-green-mobile.svg`}
                        />
                        <Image
                            className="absolute left-0 top-0 bg-transparent"
                            src={`/images/contact-us/gradient-violet-mobile.svg`}
                        />
                    </div>
                    <div className="flex flex-col items-center md:flex-row md:justify-between md:items-center p-4 md:px-6 md:py-[26px] lg:pl-18 lg:pr-22 max-w-screen-maxScreen mx-auto">
                        <div className="top-0 max-w-[328px] md:max-w-full z-50">
                            <ContactHeading />
                        </div>
                        <Image
                            src="/images/contact-us/contact-us-header.svg"
                            className="pt-12 md:pt-3 md:pr-5 md:w-[217px] md:h-[164px] xl:w-[236px] xl:h-[181px]"
                        />
                    </div>
                </div>
            </div>

            <div className="max-w-screen-maxScreen mx-auto">
                <div className="xl:mx-[72px] xl:my-10 p-4 md:p-6 bg-basicWhite rounded-lg xl:shadow-custom-sm">
                    <div className="flex flex-col xl:flex-row gap-6 xl:gap-12">
                        <div className="xl:flex-1 flex flex-col gap-4 md:gap-6 lg:w-4/5 xl:w-full mx-auto">
                            {/* Contact Details */}
                            <div className="flex flex-col md:flex-row xl:flex-col gap-4 md:gap-2 xl:gap-6 lg:mt-2 xl:mt-0">
                                {contactDetails.map((card, index) => (
                                    <Fragment key={index}>
                                        <ContactCard
                                            key={card.value}
                                            icon={card.icon}
                                            label={card.label}
                                            value={card.value}
                                            type={card.type}
                                        />
                                    </Fragment>
                                ))}
                                {/* Social Media Icons */}
                                <div className="xl:hidden flex-1">
                                    <SocialMediaIcons
                                        socialMediaIcons={socialMediaIcons}
                                    />
                                </div>
                            </div>
                            {/* Social Media Icons */}
                            <div className="hidden xl:block">
                                <SocialMediaIcons
                                    socialMediaIcons={socialMediaIcons}
                                />
                            </div>
                            {/* Address Details */}
                            <div className="flex flex-col md:flex-row xl:flex-col gap-4 md:gap-2 xl:gap-6">
                                {addressDetails.map((card, index) => (
                                    <Fragment key={index}>
                                        <ContactCard
                                            key={card.value}
                                            icon={card.icon}
                                            label={card.label}
                                            value={card.value}
                                            type={card.type}
                                        />
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                        <div className="xl:flex-1 w-full lg:w-4/5 xl:w-full mx-auto shadow-custom-sm xl:shadow-none rounded-lg">
                            <ContactDetails
                                onSubmit={onSubmit}
                                loading={loading}
                                message={message}
                                error={error}
                                contactFormRef={contactForm}
                            />
                            {message && (
                                <div className="xl:hidden pb-4 md:pb-6 px-4 md:px-6">
                                    <MessageToaster
                                        message={message}
                                        error={error}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {message && (
                        <div className="hidden xl:flex w-full justify-end">
                            <div className="w-[48%]">
                                <MessageToaster
                                    message={message}
                                    error={error}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ContactUS;
